import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'
import CheckboxInput from 'components/Luxkit/Checkbox/CheckboxInput'

const CloseProximityContainer = styled.div`
  padding: ${rem(24)} ${rem(20)};
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
`

interface Props {
  checked: boolean;
  onToggleConnectRooms: () => void;
  className?: string;
}

function RequestConnectingRoomsInput(props: Props) {
  const { checked, onToggleConnectRooms, className } = props

  return (
    <CloseProximityContainer className={className}>
      <CheckboxInput checked={checked} onChange={onToggleConnectRooms}>
        <BodyText variant="medium" weight="bold">Request connecting rooms</BodyText>
        <BodyText variant="medium">Connecting rooms are dependant on hotel availability and will be confirmed at time of check-in.</BodyText>
      </CheckboxInput>
    </CloseProximityContainer>
  )
}

export default RequestConnectingRoomsInput
